'use client';

import { useEffect } from 'react';

import { LayoutContainer } from '~components/LayoutContainer/LayoutContainer';
import { SectionMods } from '~components/Section/Section.types';
import { SectionSubscribe } from '~components/SectionSubscribe/SectionSubscribe';
import { mapBlocksToJSX } from '~containers/MainPage/MainPage.utils';
import { useTheme } from '~hooks/useTheme';
import { ThemesNames } from '~types/Theme.types';

import styles from './MainPage.module.scss';
import { MainPageProps } from './MainPage.types';

export const MainPage = ({ blocks, sectionSubscribe }: MainPageProps) => {
  const { setTheme } = useTheme();

  useEffect(() => {
    setTheme(ThemesNames.White);
  }, [setTheme]);

  return (
    <LayoutContainer>
      <div className={styles.blocksContainer}>
        {blocks?.length && mapBlocksToJSX(blocks)}
      </div>
      {!sectionSubscribe.isHidden && (
        <SectionSubscribe
          mods={[SectionMods.SeparatorS]}
          {...sectionSubscribe}
        />
      )}
    </LayoutContainer>
  );
};
